import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { ClientPurchaseOrder, ClientPurchaseOrderSearchCommand } from '../../models/order/client-purchase-order';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ClientPurchaseOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.orderApi}/api/v1/client-purchase-order`;

  getById(id: string): Observable<ApiResponse<ClientPurchaseOrder>> {
    return this.httpClient.get<ApiResponse<ClientPurchaseOrder>>(`${this.baseUrl}/${id}`);
  }

  search(
    command: ClientPurchaseOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<ClientPurchaseOrder>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) {
      params = params.set('sortField', sortField).set('sortOrder', sortOrder.toString());
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ClientPurchaseOrder>>>(`${this.baseUrl}/search`, command, { params });
  }
}
